import React, { useState, useEffect, useRef } from "react";
import { Form, Input } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

export default function SessionBaseAuthForm(props) {
  const [cookieText, setCookieText] = useState("");
  const [password, setPassword] = useState("");
  const [cookieTextError, setCookieTextError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Initialize form data from props
  useEffect(() => {
    if (props.authData && !isInitialized) {
      const initialCookieText = props.authData.cookieText || "";
      const initialPassword = props.authData.password || "";

      setCookieText(initialCookieText);
      setPassword(initialPassword);
      setIsInitialized(true);

      // Call validation check
      validateForm(initialCookieText, initialPassword);
    } else if (!props.authData && !isInitialized) {
      setIsInitialized(true);
      validateForm("", "");
    }
  }, [props.authData, isInitialized]);

  // Validate form and notify parent
  const validateForm = (cookieTextValue, passwordValue) => {
    const isCookieTextValid = cookieTextValue.trim() !== "";
    const isPasswordValid = passwordValue.trim() !== "";
    const isFormValid = isCookieTextValid && isPasswordValid;

    if (props.onValidationChange) {
      props.onValidationChange(isFormValid);
    }

    return isFormValid;
  };

  const handleChangeCookieText = (e) => {
    const value = e.target.value;
    setCookieText(value);
    setCookieTextError(false);

    const updatedParams = {
      cookieText: value,
      password: password,
    };

    props.handleChangeValues(updatedParams);
    validateForm(value, password);
  };

  const handleChangePassword = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError(false);

    const updatedParams = {
      cookieText: cookieText,
      password: value,
    };

    props.handleChangeValues(updatedParams);
    validateForm(cookieText, value);
  };

  return (
    <div>
      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Cookies to Forward"
        required
        rules={[{ required: true, message: "Please input cookieText!" }]}
        validateStatus={cookieTextError ? "error" : ""}
      >
        <Input
          value={cookieText}
          onChange={handleChangeCookieText}
          disabled={props.isViewOnly}
          placeholder="Enter cookies to forward"
        />
      </Form.Item>

      <Form.Item
        style={{ marginBottom: "8px" }}
        label="Password"
        required
        rules={[{ required: true, message: "Please input password!" }]}
        validateStatus={passwordError ? "error" : ""}
      >
        <Input.Password
          iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          visibilityToggle={!props.isViewOnly && !props.isDisabled}
          value={password}
          onChange={handleChangePassword}
          disabled={props.isViewOnly}
          placeholder="Enter password"
        />
      </Form.Item>
    </div>
  );
}
